import "./../styles/service.css";
import React from "react";
// import React from 'react';
const DigitalTwin = () => {
  const advantageList = [
    {
      src: "/assets/advantage1.png",
      title: "数据优势",
      content:
        "融合多源多行业地址数据、不动产登记数据、民政数据等多源行业地址数据，覆盖全、更新快。",
    },
    {
      src: "/assets/advantage2.png",
      title: "技术优势",
      content:
        "基于 NLP 人工智能大模型，处理海量地址数据，挖掘地址别名等信息，提升分词与匹配精度。",
    },
    {
      src: "/assets/advantage3.png",
      title: "地址治理优势",
      content:
        "支持存量地址标准化、地址补全、地址纠错、地址坐标解析、地址关联等在内的一系列专业地址服务，增量地址规范标准化统一运营。",
    },
    {
      src: "/assets/advantage4.png",
      title: "地址服务优势",
      content:
        "提供8大类地址服务能力，如服务运维的地址智能查询，服务中台业务的地址统一编码等能力，持续夯实城市统一地址服务能力。",
    },
  ];
  const functionList = [
    {
      src: "/assets/funcation1.png",
      title: "行政区划规范",
      content:
        "确保地址中的行政区划信息按照国家规定的行政级别和顺序书写。对于一些容易混淆的行政区划名称，如简称、旧称等进行统一。",
    },
    {
      src: "/assets/funcation2.png",
      title: "道路名称和门牌号规范",
      content:
        "对道路名称进行标准化，纠正错别字、统一路名的中英文写法等。门牌号也需要按照一定的规则进行整理，如按照顺序编号、补充缺失的门牌号信息等。",
    },
    {
      src: "/assets/funcation3.png",
      title: "建筑物名称规范",
      content:
        "明确建筑物的正式名称，对一些别名、俗称进行统一。同时，要规范建筑物名称与其他地址信息的组合方式。",
    },
  ];

  return (
    <div className="service">
      <img src="/assets/service.png" alt="服务能力" />
      <div className="title">
        <div className="titleBefore">地址治理系列</div>
        <div className="titleEnd">ADDRESS MANAGEMENT</div>
        <div className="temp"></div>
      </div>

      <div className="content2 ">
        <div
          className="content-item1"
          style={{ backgroundImage: `url(/assets/bgAddress.png)` }}
        >
          <div className="content-title">产品介绍</div>
          <div className="content-content">
            江苏云网数智依托前沿人工智能技术，整合海量跨行业地名地址数据，打造全量标准化地址库，推出地址治理系列产品，为客户提供包括地址清洗、标准化、运营管理等专业服务，满足其对地址数据精准、规范、高效管理的需求，助力客户实现地址数据价值最大化，提供坚实数据支撑与保障。{" "}
          </div>
        </div>

        <div className="content-item2">
          <div className="content-title">产品优势</div>
          <div className="content-content">
            {advantageList.map((item, index) => {
              return (
                <div className="item" key={index}>
                  <img src={item.src} alt={item.title} />
                  <div className="item-title">{item.title}</div>
                  <span>{item.content}</span>
                </div>
              );
            })}
          </div>
        </div>
        <div className="content-item3">
          <div className="content-item3-temp">
            <div className="content-title">产品功能</div>
            <div className="content-content">
              <div className="content-content-item">
                <div className="content-content-item-title">
                  <img src="/assets/point-icon.png" />
                  <span>产品功能</span>
                </div>
                <div className="content-content-item-content">
                  运用NLP自然语言大模型进行15级地址格式化处理。
                </div>
                <div className="content-content-item-list">
                  {functionList.map((item, index) => {
                    return (
                      <div key={index} className="content-content-item-item">
                        <img src={item.src} alt={item.title} />
                        <div className="item-title">{item.title}</div>
                        <span>{item.content}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="content-content-item">
                <div className="content-content-item-title">
                  <img src="/assets/point-icon.png" />
                  <span>地址清洗</span>
                </div>
                <div className="content-content-item-content">
                  对地址数据进行格式标准化、地址补全、地址纠错、地址评价等使地址信息准确、规范、完整，从而提升数据质量，满足各类业务对地址数据的精准要求。
                </div>
              </div>
              <div className="content-content-item">
                <div className="content-content-item-title">
                  <img src="/assets/point-icon.png" />
                  <span>地址运营管理</span>
                </div>
                <div className="content-content-item-content">
                  地址运营管理是对地址数据的综合管理运用。包括地址数据的增删改查、数据库管理、匹配分析及与业务系统集成，依靠GIS、大数据、AI
                  等技术，保障数据质量，优化业务流程，挖掘数据价值以支持企业决策。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content-item4">
          <div className="content-title">应用场景</div>
          <div className="content-content">
            <div className="content-content-item">
              <div className="content-content-item-title">
                <img src="/assets/point-icon.png" />
                <span>通信运营商行业</span>
              </div>
              <div className="content-content-item-content">
                <div className="item">
                  <div className="item-title">客户群体</div>
                  <div className="item-content">
                    各省市级通信运营商（联通、移动、电信）网络部、综合资源管理等。
                  </div>
                </div>
                <div className="item">
                  <div className="item-title">应用场景</div>
                  <div className="item-content">
                    业务支撑、市场营销、资源可视化、网络优化、应急保障
                  </div>
                </div>
              </div>
              <div className="content-content-item-title">
                <img src="/assets/point-icon.png" />
                <span>能源行业</span>
              </div>
              <div className="content-content-item-content">
                <div className="item">
                  <div className="item-title">客户群体</div>
                  <div className="item-content">水电气能源单位</div>
                </div>
                <div className="item">
                  <div className="item-title">应用场景</div>
                  <div className="item-content">
                    数字化用电地址库、用电地址定位、停电范围预判、报修定位调度、服务热点区域分析、设备地址搜索
                  </div>
                </div>
              </div>
              <div className="content-content-item-title">
                <img src="/assets/point-icon.png" />
                <span>政府行业</span>
              </div>
              <div className="content-content-item-content">
                <div className="item">
                  <div className="item-title">客户群体</div>
                  <div className="item-content">公安、大数据局</div>
                </div>
                <div className="item">
                  <div className="item-title">应用场景</div>
                  <div className="item-content">
                    警用地理信息平台； 政务地址服务
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="content-end">
          加入云网合作伙伴，开创新业务，获取技术、资源
        </div>
      </div>
    </div>
  );
};
export default DigitalTwin;
